import { useNavigate } from 'react-router-dom';

const SearchPopularArtists = ({ artists }) => {
  
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3 lg:gap-4 w-full">
      {artists.map((artist) => (
        <div
          key={artist.id}
          className="bg-charcoal p-4 hover:bg-hover-charcoal rounded-lg cursor-pointer transition duration-200"
          onClick={() => navigate(`/artist/${artist.id}`)}
        >
          <div className="relative pb-[100%]">
            <img
              src={artist.image}
              alt={artist.name}
              className="absolute top-0 left-0 w-full h-full rounded-full object-cover"
              draggable="false"
            />
          </div>
          <div className="text-center pt-[0.5rem]">
            <h1 className="text-lg font-bold line-clamp-1">{artist.name}</h1>
            <p className="text-sm line-clamp-1">{artist.type}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SearchPopularArtists;